// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slick-prev {
  margin-left: 1rem !important;
}

.slick-next {
  margin-right: 1rem !important;
}

.slick-arrow::before {
  opacity: 0.8;
}

.detail-container {
  display: flex;
}

/* .detail-option-container {
  min-width: 422.5px;
  background-color: #fff;
  padding: 82.5px 23.5px 0 23.5px;
} */

.detail-info-container {
  width: calc(100% - 425.5px);
  /* margin-left: 10px; */
  padding-top: 12px;
  background-color: #fff;
}

.my-detail-container {
  width: calc(100% - 153px);
}

.detail_info_title {
  background-color: #fff;
  padding-left: 17px;
  padding-right: 17px;
  padding-bottom: 10px;
  padding-top: 20px;
  position: sticky;
  top: -1px;
  z-index: 999;
}

.detail_info_tag {
  background-color: #fff;
  padding-left: 17px;
  padding-right: 34px;
}

.detail_info_price {
  background-color: #fff;
  padding-left: 34px;
  padding-right: 34px;
}

.detail_info_result {
  background-color: #fff;
  padding-left: 34px;
  padding-right: 34px;
  padding-bottom: 11px;
  padding-top: 19px;
  position: sticky;
  top: 52.5px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;
}

.gap-3px {
  gap: 3px;
}

.button_wrapper {
  display: flex;
  justify-content: center;
}

.py-7px {
  padding-top: 7px;
  padding-bottom: 7px;
}

.detail-option-scroll-container {
  overflow-y: auto;
}

.detail-option-scroll-container::-webkit-scrollbar {
  display: none;
}

.detail-option-scroll-container {
  -ms-overflow-style: none;
  /* 인터넷 익스플로러 */
  scrollbar-width: none;
  /* 파이어폭스 */
}


@media (max-width: 1679px) {
  .my-detail-container {
    width: calc(100% - 231px);
    background: linear-gradient(to right, transparent 70%, white 30%);
  }
}

@media (max-width: 1280px) {
  .detail-option-container {
    padding-top: 50px;
  }

  .detail-container {
    height: calc((var(--vh, 1vh) * 100) - 153.9px);
    overflow: hidden;
    /* flex-direction: column; */
  }

  .detail-info-container {
    /* width: 100%; */
    margin-left: 0;
  }

  .detail_info_title {
    padding-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .detail_info_result {
    justify-content: space-between;
    gap: 0;
  }

  .price_wrapper {
    width: 66.666%;
  }

  .button_wrapper {
    flex-grow: 1;
  }

  .button_wrapper {
    flex-direction: column;
    align-items: center;
  }

  .detail-container {
    flex-direction: column;
    height: calc((var(--vh, 1vh) * 100) - 112.9px);
    overflow: auto;
  }

  .detail_info_title {
    padding-bottom: 10px;
  }

  .detail-info-container {
    width: 100%;
  }
}

@media (max-width: 422.5px) {
  .detail-option-container {
    min-width: inherit;
  }
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal>.swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  left: 50%;
  right: 50%;
  width: max-content;
  transform: translate(-50%, 0);
}

@media (max-height: 700px) {
  .detail-option-container {
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/pages.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;GAIG;;AAEH;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;;;AAGA;EACE;IACE,yBAAyB;IACzB,iEAAiE;EACnE;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,8CAA8C;IAC9C,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,MAAM;EACR;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,8CAA8C;IAC9C,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;EAIE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".slick-prev {\n  margin-left: 1rem !important;\n}\n\n.slick-next {\n  margin-right: 1rem !important;\n}\n\n.slick-arrow::before {\n  opacity: 0.8;\n}\n\n.detail-container {\n  display: flex;\n}\n\n/* .detail-option-container {\n  min-width: 422.5px;\n  background-color: #fff;\n  padding: 82.5px 23.5px 0 23.5px;\n} */\n\n.detail-info-container {\n  width: calc(100% - 425.5px);\n  /* margin-left: 10px; */\n  padding-top: 12px;\n  background-color: #fff;\n}\n\n.my-detail-container {\n  width: calc(100% - 153px);\n}\n\n.detail_info_title {\n  background-color: #fff;\n  padding-left: 17px;\n  padding-right: 17px;\n  padding-bottom: 10px;\n  padding-top: 20px;\n  position: sticky;\n  top: -1px;\n  z-index: 999;\n}\n\n.detail_info_tag {\n  background-color: #fff;\n  padding-left: 17px;\n  padding-right: 34px;\n}\n\n.detail_info_price {\n  background-color: #fff;\n  padding-left: 34px;\n  padding-right: 34px;\n}\n\n.detail_info_result {\n  background-color: #fff;\n  padding-left: 34px;\n  padding-right: 34px;\n  padding-bottom: 11px;\n  padding-top: 19px;\n  position: sticky;\n  top: 52.5px;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 100px;\n}\n\n.gap-3px {\n  gap: 3px;\n}\n\n.button_wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.py-7px {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n\n.detail-option-scroll-container {\n  overflow-y: auto;\n}\n\n.detail-option-scroll-container::-webkit-scrollbar {\n  display: none;\n}\n\n.detail-option-scroll-container {\n  -ms-overflow-style: none;\n  /* 인터넷 익스플로러 */\n  scrollbar-width: none;\n  /* 파이어폭스 */\n}\n\n\n@media (max-width: 1679px) {\n  .my-detail-container {\n    width: calc(100% - 231px);\n    background: linear-gradient(to right, transparent 70%, white 30%);\n  }\n}\n\n@media (max-width: 1280px) {\n  .detail-option-container {\n    padding-top: 50px;\n  }\n\n  .detail-container {\n    height: calc((var(--vh, 1vh) * 100) - 153.9px);\n    overflow: hidden;\n    /* flex-direction: column; */\n  }\n\n  .detail-info-container {\n    /* width: 100%; */\n    margin-left: 0;\n  }\n\n  .detail_info_title {\n    padding-bottom: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .detail_info_result {\n    justify-content: space-between;\n    gap: 0;\n  }\n\n  .price_wrapper {\n    width: 66.666%;\n  }\n\n  .button_wrapper {\n    flex-grow: 1;\n  }\n\n  .button_wrapper {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .detail-container {\n    flex-direction: column;\n    height: calc((var(--vh, 1vh) * 100) - 112.9px);\n    overflow: auto;\n  }\n\n  .detail_info_title {\n    padding-bottom: 10px;\n  }\n\n  .detail-info-container {\n    width: 100%;\n  }\n}\n\n@media (max-width: 422.5px) {\n  .detail-option-container {\n    min-width: inherit;\n  }\n}\n\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-horizontal>.swiper-pagination-bullets,\n.swiper-pagination-bullets.swiper-pagination-horizontal {\n  left: 50%;\n  right: 50%;\n  width: max-content;\n  transform: translate(-50%, 0);\n}\n\n@media (max-height: 700px) {\n  .detail-option-container {\n    padding-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
